export default __webpack_public_path__ + "static/media/registration-settings.067ed094.png";